// extracted by mini-css-extract-plugin
module.exports = {"comments":"bc_fb","comments__list":"bc_fc"};